<template>
  <SearchBar />
</template>

<script>
import SearchBar from "@/components/global/SearchBar.vue";

export default {
  name: "Search",
  components: {
    SearchBar,
  },
};
</script>

<style scoped></style>
